import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Share2, Check } from "lucide-react";

// Private areas where the share button should NOT appear.
const HIDDEN = ["/account", "/admin", "/cart", "/order", "/login", "/register", "/forgot-password", "/reset-password", "/messages", "/welcome"];

const isHidden = (pathname) => {
  if (pathname === "/seller" || pathname.startsWith("/seller/")) return true; // dashboard (keeps /seller-agreement public)
  return HIDDEN.some((p) => pathname === p || pathname.startsWith(p + "/"));
};

export default function ShareButton() {
  const { pathname } = useLocation();
  const [copied, setCopied] = useState(false);

  if (isHidden(pathname)) return null;

  const share = async () => {
    const url = window.location.href; // read at click time → always the current page
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); } catch (_) {}
      document.body.removeChild(ta);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      type="button"
      data-testid="share-page-btn"
      onClick={share}
      aria-label="Share this page"
      className="fixed bottom-5 left-5 z-40 inline-flex items-center gap-2 rounded-full border border-border bg-background/80 backdrop-blur px-4 py-2.5 text-sm text-foreground shadow-sm hover:text-primary hover:border-primary transition-colors"
    >
      {copied ? <Check className="w-4 h-4 text-primary" /> : <Share2 className="w-4 h-4" />}
      <span className="hidden sm:inline">{copied ? "Link copied!" : "Share this page"}</span>
      <span className="sm:hidden">{copied ? "Copied!" : "Share"}</span>
    </button>
  );
}
